import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { HeaderDefaultComponent } from './layouts/header-default.component';
import { HeaderGameComponent } from './layouts/header-game.component';
import { HeaderBondMathComponent } from './layouts/header-bondmath.component';
import { HeaderHorizonCalcComponent } from './layouts/header-horizoncalc.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'dashboard',
        outlet: 'app-header',
        component: HeaderDefaultComponent
      },
      {
        path: 'game',
        loadChildren: './game/game.module#GameModule'
      },
      {
        path: 'game',
        outlet: 'app-header',
        component: HeaderGameComponent
      },
      {
        path: 'bondmath',
        loadChildren: './bondmath/bondmath.module#BondMathModule'
      },
      {
        path: 'bondmath',
        outlet: 'app-header',
        component: HeaderBondMathComponent
      },
      {
        path: 'horizoncalc',
        loadChildren: './horizoncalc/horizoncalc.module#HorizonCalcModule'
      },
      {
        path: 'horizoncalc',
        outlet: 'app-header',
        component: HeaderHorizonCalcComponent
      },
      {
        path: 'disclaimer',
        loadChildren: './disclaimer/disclaimer.module#DisclaimerModule'
      },
      {
        path: 'disclaimer',
        outlet: 'app-header',
        component: HeaderDefaultComponent
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts